import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  adminToken: localStorage.getItem('adminToken'),
  agentToken: localStorage.getItem('agentToken'),
  loading: false,
  error: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAdminToken: (state, action) => {
      state.adminToken = action.payload;
      if (action.payload) {
        localStorage.setItem('adminToken', action.payload);
      } else {
        localStorage.removeItem('adminToken');
      }
    },
    setAgentToken: (state, action) => {
      state.agentToken = action.payload;
      if (action.payload) {
        localStorage.setItem('agentToken', action.payload);
      } else {
        localStorage.removeItem('agentToken');
      }
    },
    logout: (state) => {
      state.adminToken = null;
      state.agentToken = null;
      localStorage.removeItem('adminToken');
      localStorage.removeItem('agentToken');
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setAdminToken, setAgentToken, logout, setLoading, setError } = authSlice.actions;
export default authSlice.reducer;
